/*
|--------------------------------------------------------------------------
| Views: Portrait Slider
|--------------------------------------------------------------------------
*/

/**
 * Portrait Slider
 * @namespace
 */
__gh__webApp.views.portraitSlider = {

	"callbacks": function(bucket){
		__gh__webApp.utilities.slider.loadAllSliders();
	},


	"getSubView": function(bucket){

		//Update bucket
		bucket.view.name 					= "buckets/portraitSlider/default";
		bucket.view.sliderSettings 			= this.getSliderSettings(bucket.id);
		return bucket;
	},


	"getSliderSettings":function(bucketID){
		var sliderSettings = {
				"infinite": true,
				"speed": 300,
				"slidesToShow": 6,
				"slidesToScroll": 6,
				"lazyLoad": "ondemand",
				"responsive": [{
					"breakpoint": 1280,
					"settings": {
						// "appendArrows": "#gh-slider-nav-bottom-"+bucketID
					}
				}, {
					"breakpoint": 1024,
					"settings": {
						"slidesToShow": 6,
						"slidesToScroll": 6,
						// "appendArrows": "#gh-slider-nav-bottom-"+bucketID
					}
				}, {
					"breakpoint": 768,
					"settings": {
						"slidesToShow": 4,
						"slidesToScroll": 4,
						// "appendArrows": "#gh-slider-nav-bottom-"+bucketID
					}
				}, {
					"breakpoint": 480,
					"settings": {
						"slidesToShow": 2,
						"slidesToScroll": 2,
						// "appendArrows": "#gh-slider-nav-bottom-"+bucketID
					}
				}]
			};

			return sliderSettings;
	}

};
